import React, {createContext, useContext, useState, ReactNode} from 'react'

interface DragContextType {
  draggedBlockPath: string | null
  isDragging: boolean
  setDraggedBlock: (path: string | null) => void
  setIsDragging: (isDragging: boolean) => void
  resetDrag: () => void
}

const DragContext = createContext<DragContextType | undefined>(undefined)

export const DragProvider: React.FC<{children: ReactNode}> = ({children}) => {
  const [draggedBlockPath, setDraggedBlockPath] = useState<string | null>(null)
  const [isDragging, setIsDragging] = useState(false)

  const setDraggedBlock = (path: string | null) => {
    setDraggedBlockPath(path)
  }

  const resetDrag = () => {
    setDraggedBlockPath(null)
    setIsDragging(false)
  }

  return (
    <DragContext.Provider
      value={{
        draggedBlockPath,
        isDragging,
        setDraggedBlock,
        setIsDragging,
        resetDrag,
      }}
    >
      {children}
    </DragContext.Provider>
  )
}

export const useDrag = () => {
  const context = useContext(DragContext)
  if (!context) {
    throw new Error('useDrag must be used within a DragProvider')
  }
  return context
}
